import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { HelperService } from '../../../shared/services/helper.service';
import { HttpService } from '../../../shared/services/http.service';
import { ToastService } from '../../../shared/services/toast.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-wp',
  templateUrl: './wp.component.html',
  styleUrl: './wp.component.css',
})
export class WpComponent {
  helper = inject(HelperService);
  http = inject(HttpService);
  toast = inject(ToastService);
  isApproval: boolean = false;
    @Output() updateState = new EventEmitter<any>();
  
  constructor() {}

  approveUrl = `${environment.opbBackendHost}/api/admin/approval/approve`;

  @Input() wp: any = '';

  openApprovalModal() {
    this.isApproval = true;
  }

  onApprove(id: any) {
    this.http.post(this.approveUrl, { approval_id: id }).subscribe(
      (response: any) => {
        this.updateState.emit(response.data)
        this.toast.success('Success', 'Approved successfully');
        this.closeApprove()
      },
      (error) => {
        this.toast.error('Error', 'Approval failed');
        this.closeApprove()

      }
    );
  }

  closeApprove() {
    this.isApproval = false;
  }
}
